<script>
  import { locale } from 'svelte-i18n';
  export let iso;
  export let active;
  export let theme;

  function setLocale() {
    locale.set(iso);
    localStorage.setItem('lang', iso);
  }
</script>

<label
  for={`lang-${iso}`}
  class:radio-circle={active}
  class:radio-circle--white={active && theme === 'white'}
  class={`language-label mx-[10px] xl:mx-[12px] text-base xl:text-xs theme-${theme}`}
>
  <input
    class="absolute hidden"
    type="radio"
    name="lang"
    id={`lang-${iso}`}
    checked={active}
    on:change={setLocale}
  />
  <span class={`language-iso capitalize ${active ? 'opacity-100' : 'opacity-60'}`}>{iso}</span>
</label>

<style>
  @media screen and (max-width: 1023px) {
    .radio-circle {
      border-color: var(--border-gray) !important;
    }

    .radio-circle--white {
      border-color: var(--border-gray) !important;
    }

    .language-iso {
      color: black !important;
    }
  }

  .language-label {
    min-width: 28px;
    @apply relative flex items-center justify-center cursor-pointer;
  }
  .language-label:hover .language-iso {
    @apply opacity-100;
  }

  .radio-circle {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 1px solid var(--border-gray);
    margin: 0 !important;
  }

  .radio-circle:hover {
    border-color: #000 !important;
  }

  .radio-circle--white:hover {
    border-color: #fff !important;
  }
  @media screen and (min-width: 1601px) {
    .radio-circle {
      width: 56px;
      height: 56px;
    }
  }
</style>
